import * as _ from "lodash";
import * as $ from "jquery";

import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { GfxUtils, NodeType } from "../../../common/gfxUtils";
import { ColorConstants } from "../../../common/constants";
import { UiUtils } from "../../../common/uiUtils";
import { Misc } from "../../../common/misc";
import { GeometryTools } from "../../../common/geometryTools";
import { BalconyGroup, BalconyInfo, BalconyPanel } from "./balconyInfo";
import { StepVisualizer } from "./stepVisualizer";
import { ShareUtils } from "../../share/shareUtils";

enum MeasurementStep {
    None,
    Add,
    Finish
}

interface MeasurementProps {
    viewer: Autodesk.Viewing.GuiViewer3D;
    selectedBalconyId: number;
    addMeasurements: (balconyId: number, meas) => void;
    initBalconyMeasurements: (balconyId: number) => void;
    closeWizard: () => void;
    originalModelId: number;
    panelsModelId: number;
    gfxUtils: GfxUtils;
}

export function MeasurementSteps(props: MeasurementProps) {
    const mRef = useRef(null);

    const [step, setStep] = useState(MeasurementStep.Add);
    const [selectedId, setSelectedId] = useState<number>(null);
    const [selectedBalconyId, setSelectedBalconyId] = useState<number>(props.selectedBalconyId);
    const [helpText, setHelpText] = useState("");

    const showMeasurementTool = () => {
        //props.initBalconyMeasurements(props.selectedBalconyId);
        const measExt = props.viewer.getExtension("Autodesk.Measure") as Autodesk.Extensions.Measure.MeasureExtension;
        measExt.activate("distance");
    }

    const collectMeasurements = () => {
        const measExt = props.viewer.getExtension("Autodesk.Measure") as Autodesk.Extensions.Measure.MeasureExtension;
        measExt.activate("distance");
        const measurements = measExt.getMeasurementList() as any;
        measExt.deactivate();

        const distances = measurements.filter(m => m.type === "Distance");

        return distances.map(d => {
            const picks = d.picks.map(p => {
                let pick = _.pick(p, "intersection", "modelId", "viewportIndex2d");
                pick.intersection = new THREE.Vector3(pick.intersection.x, pick.intersection.y, pick.intersection.z).toModelUnits();
                return pick;
            });
            const [value, unit] = d.distance.split(" ");

            return {
                type: d.type,
                precision: d.precision,
                value: Number(value),
                unit: unit,
                picks: picks
            };
        });
    }

    useEffect(() => {
        showMeasurementTool();
    }, []);

    useEffect(() => {
        setStep(MeasurementStep.Add);
    }, [selectedBalconyId]);

    useEffect(() => {
        switch (step) {
            case MeasurementStep.Add:
                //props.viewer.clearSelection();
                setHelpText("Add dimension objects");
                break;
            case MeasurementStep.Finish:
                setHelpText("Add measurements to balcony");
                break;
            default:
                setHelpText("This is an area for help texts");
        }
    }, [step]);

    return (
        <div id="steps-react" className="react-content m-1">
            <div>
                <div className="row pt-1 pb-2">
                    <div className="col d-flex justify-content-center">
                        <StepVisualizer steps={["Add", "Save"]} currentStep={step} />
                    </div>
                </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center mt-1 mb-2 border border-white" style={{ height: "50px" }}>
                <span style={{ fontSize: "medium" }}>{helpText}</span>
            </div>

            <div className="row py-1">
                <div className="col d-flex justify-content-center">
                    {step != MeasurementStep.Finish ? "Object id: " + (selectedId ?? "") : " "}
                </div>
            </div>

            <div className="row align-items-center justify-content-between py-1">
                <div className="col">
                    <button id="cancel" className="btn btn-secondary"
                        onClick={(e) => {
                            //removeMeasurementsFromScreen();
                            props.closeWizard();
                        }}>
                        Cancel
                    </button>
                </div>
                <div className="col">
                    <button id="stop1" className="btn btn-primary float-right"
                        //disabled={step != MeasurementStep.Finish && selectedId === null}
                        onClick={async (e) => {
                            setSelectedId(null);
                            setStep((prev) => prev + 1);
                            switch (step) {
                                case MeasurementStep.Add:
                                    let meas = collectMeasurements(); // ShareUtils.measurementsFromExtension(props.viewer);
                                    mRef.current = meas;
                                    break;
                                case MeasurementStep.Finish:
                                    //removeMeasurementsFromScreen();
                                    props.addMeasurements(props.selectedBalconyId, mRef.current);
                                    setStep(MeasurementStep.None);

                                    break;
                                default:
                            }
                        }}>
                        {step < MeasurementStep.Finish ? "Next" : "Add"}
                    </button>
                </div>
            </div>
        </div>
    );
}